import React, { useState } from 'react';
import { FaWhatsapp, FaTimes } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';
import { useSettings } from '../../context/SettingsContext';

const WhatsAppButton = () => {
    const [showPopup, setShowPopup] = useState(false);
    const { settings, loading } = useSettings();

    if (loading || !settings || !settings.whatsappButton?.isVisible) return null;

    const { phoneNumber, defaultMessage, popupTitle, popupMessage } = settings.whatsappButton;

    const handleClick = () => {
        const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(defaultMessage)}`;
        window.open(url, '_blank');
    };

    return (
        <div className="fixed bottom-6 right-6 z-50">
            {/* Same code as before, but use popupTitle, popupMessage instead of hardcoded text */}
            <AnimatePresence>
                {showPopup && (
                    <motion.div
                        initial={{ opacity: 0, scale: 0.8, y: 20 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.8, y: 20 }}
                        className="absolute bottom-20 right-0 w-72 bg-white rounded-2xl shadow-2xl overflow-hidden"
                    >
                        <div className="bg-green-500 p-4 text-white">
                            <div className="flex justify-between items-center">
                                <h4 className="font-semibold">{popupTitle}</h4>
                                <button onClick={() => setShowPopup(false)}><FaTimes /></button>
                            </div>
                            <p className="text-sm opacity-90 mt-1">{popupMessage}</p>
                        </div>
                        <div className="p-4">
                            <button
                                onClick={handleClick}
                                className="w-full bg-green-500 text-white py-3 rounded-lg font-semibold hover:bg-green-600 transition flex items-center justify-center"
                            >
                                <FaWhatsapp className="mr-2 text-xl" />
                                Start Chat
                            </button>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>

            <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                onClick={() => setShowPopup(!showPopup)}
                className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center shadow-lg"
            >
                <FaWhatsapp className="text-white text-3xl" />
            </motion.button>
        </div>
    );
};

export default WhatsAppButton;